const state = {
    title: 'Help a Hero',
};

const getters = {
    pageTitle: state => {
        return state.title;
    }
};

const actions = {
    setPageTitle({commit, state}, title) {
        commit('setTitle', title);
    }
};

const mutations = {
    setTitle(state, title) {
        if (_.isEmpty(title)) {
            title = 'Loading'
        }
        state.title = title + ' | Help a Hero';

        document.title = state.title;
    }
};

export default {
    state, getters, actions, mutations,
}
